import { jsx } from 'react/jsx-runtime';
import React__default from 'react';

const Void = ({ key, children }) => {
  return /* @__PURE__ */ jsx(React__default.Fragment, {
    children
  }, key);
};

export { Void };
//# sourceMappingURL=Void.js.map
